import { MutationOptions } from 'react-query';
import { queryClient } from '../../../queryClient';
import {
  addPartnerFarm,
  updatePartnerFarmKey,
  updatePartnerFarmStatus,
} from './solar-farm-partners.api';
import {
  PartnerFarmResponse,
  UpdatePartnerFarmStatusRequest,
} from './solar-farm-partners.schema';
import { FARM_PARTNERS_QUERY_KEY_PREFIX } from './solar-farm-partners.query';

interface PartnerFarmKeyVariables {
  farmId: number;
  partnerId: number;
  partner_farm_key: string;
}

const invalidateFarmPartners = (farmId: number) =>
  queryClient.invalidateQueries({
    queryKey: [FARM_PARTNERS_QUERY_KEY_PREFIX, { solarFarmId: farmId }],
    exact: false,
  });

export const getAddPartnerFarmMutation = (): MutationOptions<
  PartnerFarmResponse,
  Error,
  PartnerFarmKeyVariables
> => ({
  mutationFn: ({ farmId, partnerId, partner_farm_key }) =>
    addPartnerFarm(farmId, partnerId, { partner_farm_key }),
  onSuccess: (_, { farmId }) => invalidateFarmPartners(farmId),
});

export const getUpdatePartnerFarmKeyMutation = (): MutationOptions<
  PartnerFarmResponse,
  Error,
  PartnerFarmKeyVariables
> => ({
  mutationFn: ({ farmId, partnerId, partner_farm_key }) =>
    updatePartnerFarmKey(farmId, partnerId, { partner_farm_key }),
  onSuccess: (_, { farmId }) => invalidateFarmPartners(farmId),
});

export const getUpdatePartnerFarmStatusMutation = (
  solarFarmId: number,
  partnerId: number,
): MutationOptions<
  PartnerFarmResponse,
  Error,
  UpdatePartnerFarmStatusRequest
> => ({
  mutationFn: body => updatePartnerFarmStatus(solarFarmId, partnerId, body),
  onSuccess: () => invalidateFarmPartners(solarFarmId),
});
